export default{
    loading(state){
        return state.loading
    },
    buildPickability(state){
        return state.buildPickability
    },
    pickWave(state){
        return state.pickWave
    },
    pickWaves(state){
        return state.pickWaves
    },
    pickingLocations(state){
        return state.pickingLocations
    },
    buildInPickwave(state){
        return state.buildInPickwave
    },
    errors(state){
        return state.errors
    }
}